import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Apply saved colour theme before first paint to avoid flash of wrong theme
(function () {
  const saved = localStorage.getItem("mm-color-theme") || "chrome";
  document.documentElement.setAttribute("data-theme", saved);
})();

// Unregister any stale service workers and wipe their caches.
// Previous deploys had a broken vendor-charts chunk that crashes on load;
// any browser still running that cached SW will be cleaned up here.
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    for (const reg of registrations) {
      reg.unregister();
    }
  });
  caches.keys().then((keys) => {
    for (const key of keys) {
      caches.delete(key);
    }
  });
}

createRoot(document.getElementById("root")!).render(<App />);
